// 🆕 [Phase 56.3] Extrait de CalendrierProduction.jsx — dialog "Modifier la durée du contrat".
// Ouvert quand l'utilisateur a déplacé un BT ou changé sa date de fin via la poignée
// de resize. Propose de décaler les BT suivants du même chef en cascade.
//
// Payload data : { bon, newLastDate, daysDiff, oldEnd, firstDate, moveMode? }
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

function DialogDecalage({ data, onClose, onApply }) {
  if (!data) return null;
  return (
    <Dialog open={!!data} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="w-[500px] max-w-[95vw]">
        <DialogHeader className="text-left">
          <DialogTitle>{data.moveMode ? 'Contrat deplace' : 'Modifier la duree du contrat'}</DialogTitle>
          <DialogDescription>
            {data.moveMode
              ? `Le contrat a ete deplace. Souhaitez-vous aussi decaler les contrats suivants de ${Math.abs(data.daysDiff)} jour(s) ?`
              : `Le contrat ${data.bon.chef_equipe_nom || ''} sera ${data.daysDiff > 0 ? 'prolonge' : 'raccourci'} de ${Math.abs(data.daysDiff)} jour(s).`
            }
          </DialogDescription>
        </DialogHeader>

        <div className="py-2">
          <p className="text-sm text-gray-700 mb-3">
            Nouvelle fin : <strong>{new Date(data.newLastDate + 'T12:00:00').toLocaleDateString('fr-CA', { weekday: 'long', day: 'numeric', month: 'long' })}</strong>
          </p>
          <div className={`rounded-lg p-3 ${data.daysDiff > 0 ? 'bg-amber-50 border border-amber-200' : 'bg-blue-50 border border-blue-200'}`}>
            <p className={`text-sm font-medium ${data.daysDiff > 0 ? 'text-amber-800' : 'text-blue-800'}`}>
              {data.daysDiff > 0 ? 'Décaler' : 'Avancer'} les contrats suivants ?
            </p>
            <p className={`text-xs mt-1 ${data.daysDiff > 0 ? 'text-amber-600' : 'text-blue-600'}`}>
              Tous les contrats après celui-ci seront {data.daysDiff > 0 ? 'repoussés' : 'avancés'}.
            </p>
          </div>
        </div>

        <DialogFooter className="flex-col gap-2 sm:flex-row sm:gap-2">
          <Button variant="outline" onClick={onClose}>
            Annuler
          </Button>
          <Button variant="outline" onClick={() => onApply(false)}>
            Ce contrat seulement
          </Button>
          <Button onClick={() => onApply(true)} className="bg-blue-600 hover:bg-blue-700 text-white">
            Décaler les suivants
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default DialogDecalage;
